/**
 * StingBase
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export type OrderTypeEnum = 1 | 2;

export const OrderTypeEnum = {
    NUMBER_1: 1 as OrderTypeEnum,
    NUMBER_2: 2 as OrderTypeEnum
};

